import React from 'react';
import { Building2, Users, Clock, CheckCircle, AlertTriangle, TrendingUp, DollarSign } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';

export function PlatformStatsCards({ stats }) {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="bg-gradient-to-br from-blue-500 to-blue-600 text-white border-0">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-blue-100 text-sm">Total Institutions</p>
                <p className="text-3xl font-bold mt-1">{stats?.institutions?.total || 0}</p>
              </div>
              <Building2 className="w-10 h-10 text-blue-200" />
            </div>
            <p className="text-blue-100 text-xs mt-3">
              {stats?.institutions?.recent_signups || 0} new this month
            </p>
          </CardContent>
        </Card>

        <Card className="bg-gradient-to-br from-amber-500 to-amber-600 text-white border-0">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-amber-100 text-sm">Active Trials</p>
                <p className="text-3xl font-bold mt-1">{stats?.institutions?.active_trials || 0}</p>
              </div>
              <Clock className="w-10 h-10 text-amber-200" />
            </div>
            <p className="text-amber-100 text-xs mt-3">
              {stats?.institutions?.trials_expiring_soon || 0} expiring soon
            </p>
          </CardContent>
        </Card>

        <Card className="bg-gradient-to-br from-emerald-500 to-emerald-600 text-white border-0">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-emerald-100 text-sm">Active Subscriptions</p>
                <p className="text-3xl font-bold mt-1">{stats?.institutions?.active_subscriptions || 0}</p>
              </div>
              <CheckCircle className="w-10 h-10 text-emerald-200" />
            </div>
            <p className="text-emerald-100 text-xs mt-3">
              {stats?.institutions?.suspended || 0} suspended
            </p>
          </CardContent>
        </Card>

        <Card className="bg-gradient-to-br from-purple-500 to-purple-600 text-white border-0">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-purple-100 text-sm">Total Users</p>
                <p className="text-3xl font-bold mt-1">{stats?.users?.total || 0}</p>
              </div>
              <Users className="w-10 h-10 text-purple-200" />
            </div>
            <p className="text-purple-100 text-xs mt-3">
              {stats?.patients?.total || 0} patients
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <CardContent className="p-6">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-green-100 rounded-lg">
                <DollarSign className="w-6 h-6 text-green-600" />
              </div>
              <div>
                <p className="text-sm text-slate-500">Total Revenue</p>
                <p className="text-2xl font-bold text-slate-900">
                  ₹{(stats?.revenue?.total || 0).toLocaleString()}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-red-100 rounded-lg">
                <AlertTriangle className="w-6 h-6 text-red-600" />
              </div>
              <div>
                <p className="text-sm text-slate-500">Expired Trials</p>
                <p className="text-2xl font-bold text-slate-900">
                  {stats?.institutions?.expired || 0}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-blue-100 rounded-lg">
                <TrendingUp className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <p className="text-sm text-slate-500">Conversion Rate</p>
                <p className="text-2xl font-bold text-slate-900">
                  {stats?.institutions?.total > 0 
                    ? Math.round((stats?.institutions?.active_subscriptions / stats?.institutions?.total) * 100)
                    : 0}%
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
